var map = {
	"./Logo.svg": "6e1e",
	"./arrow-left.png": "bada",
	"./arrow-right.png": "243a",
	"./banner.png": "349d",
	"./banner/1e4c898b621fa0dfae4c0ae437c7d5bb.jpg": "c4ba",
	"./banner/7ca3293606b632d7124ca3d168689fb4.jpg": "cae7",
	"./banner/Background.png": "a3f6",
	"./banner/Rectangle 25.png": "7492",
	"./banner/banner-bio.png": "1435",
	"./banner/banner-deskto 3.png": "9163",
	"./banner/banner-deskto3-mobie.png": "fb76",
	"./banner/banner-deskto_repeat.png": "ddb6",
	"./banner/banner.png": "2cdc",
	"./banner/banner2.jpg": "7d17",
	"./banner/barcode-scan-result 1.png": "ae84",
	"./banner/business.gif": "ad2b",
	"./banner/eliminate.gif": "39c3",
	"./banner/orders.gif": "27e0",
	"./banner/retailers.gif": "398c",
	"./banner_bg_1.png": "57dc",
	"./banner_bg_2.jpg": "ede7",
	"./banner_bg_3.jpg": "54ab",
	"./banner_bg_4.png": "94c2",
	"./eliminate-onboarding-issues.png": "b898",
	"./eliminate.gif": "77de",
	"./hassel-free.png": "7ef0",
	"./icon/Cancel.svg": "9cf1",
	"./icon/Frame.svg": "5657",
	"./icon/info-icon.svg": "ccc2",
	"./icon/jam_facebook-circle.svg": "c5b4",
	"./icon/jam_instagram-circle.svg": "9f87",
	"./icon/jam_linkedin-circle.svg": "733a",
	"./icon/jam_twitter-circle.svg": "5b38",
	"./icon/left-arrow.svg": "756d",
	"./icon/passwordEye.svg": "56f1b",
	"./icon/right-arrow.svg": "dc1a",
	"./icon/select_arrow.svg": "d80e",
	"./orders.gif": "719d",
	"./retailers.gif": "0612",
	"./step1.svg": "627f",
	"./step1a.svg": "c5b3",
	"./step2.svg": "5257",
	"./step2a.svg": "ce18",
	"./step3.svg": "04a0",
	"./step3a.svg": "21a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0671";